import type { SVGProps } from 'react';

const SearchMagnifyingGlass = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 18 18" fill="none" {...props}>
        <path
            fill="currentColor"
            d="M10.579 10.372L16.853 16.646C17.048 16.842 17.048 17.158 16.854 17.353C16.756 17.45 16.628 17.499 16.5 17.499C16.372 17.499 16.244 17.451 16.146 17.353L9.872 11.079C8.827 11.964 7.477 12.5 6 12.5C2.686 12.5 0 9.814 0 6.5C0 3.186 2.686 0.5 6 0.5C9.314 0.5 12 3.186 12 6.5C12 7.976 11.464 9.327 10.579 10.372ZM5.999 1.5C3.242 1.5 0.999 3.743 0.999 6.5C0.999 9.257 3.242 11.5 5.999 11.5C8.756 11.5 10.999 9.257 10.999 6.5C10.999 3.743 8.756 1.5 5.999 1.5Z"
        />
    </svg>
);

export default SearchMagnifyingGlass;
